import { render, staticRenderFns } from "./VerifiedIcon.vue?vue&type=template&id=329bd8cc&scoped=true&"
import script from "./VerifiedIcon.vue?vue&type=script&lang=js&"
export * from "./VerifiedIcon.vue?vue&type=script&lang=js&"
import style0 from "./VerifiedIcon.vue?vue&type=style&index=0&id=329bd8cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329bd8cc",
  null
  
)

export default component.exports